import { render, staticRenderFns } from "./technician.vue?vue&type=template&id=2510f86e"
import script from "./technician.vue?vue&type=script&lang=js"
export * from "./technician.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports